import { render } from "./pfdetail.vue?vue&type=template&id=4cfc811f&scoped=true"
import script from "./pfdetail.vue?vue&type=script&lang=js"
export * from "./pfdetail.vue?vue&type=script&lang=js"

import "./pfdetail.vue?vue&type=style&index=0&id=4cfc811f&lang=scss&scoped=true"
import "./pfdetail.vue?vue&type=style&index=1&id=4cfc811f&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfc811f"]])

export default __exports__